module.exports = __webpack_public_path__ + "static/media/video.1d7c73de.mp4";